import styled from 'styled-components';
import { BouColor } from '../../../generic/global/bou-colors';
import { Link, Toolbar } from './toolbar';

const links: Link[] = [
  { label: 'Products', url: `/internal/products` },
  { label: 'Product sets', url: `/blanket/my-product-sets` },
  { label: 'Deliveries', url: `/internal/deliveries` },
  { label: 'Mixins', url: `/internal/mixins` },
  { label: 'User groups', url: `/internal/user-groups` },
  { label: 'Organizations', url: '/internal/organizations' },
  { label: 'Access', url: '/internal/access' },
  { label: 'Releases', url: '/internal/versioning' },
  { label: 'Model update', url: '/internal/compute' },
  { label: 'Log', url: '/internal/log' },
  { label: 'Jobs', url: '/internal/jobs' },
];

const Root = styled.div`
  background-color: ${BouColor.TOOL_FRAME_LIGHT_GRAY};
  z-index: 100;
  border-top: 1px solid ${BouColor.TOOL_BORDER_DARK_GRAY};
  border-bottom: 1px solid ${BouColor.TOOL_BORDER_DARK_GRAY};
  padding-right: 15px;
`;

export function InternalToolsBar() {
  return (
    <Root>
      <Toolbar links={links} />
    </Root>
  );
}
